import axios from "@/libs/api.request";
// 获取列表
export const getList = params => {
  return axios.request({
    url: "/warehouse/number",
    params,
    method: "get"
  });
};
// 创建列表
export const add = data => {
  return axios.request({
    url: "/warehouse/number",
    data,
    method: "post"
  });
};
// 获取详情
export const getDetails = id => {
  return axios.request({
    url: `/warehouse/number/${id}`,
    method: "GET"
  });
};
// 更新列表
export const update = data => {
  return axios.request({
    url: `/warehouse/number/${data.id}`,
    method: "put",
    data
  });
};

// 删除列表
export const del = data => {
  return axios.request({
    url: `/warehouse/number/${data.id}`,
    method: "DELETE"
  });
};

export const inboundSave = data => {
  return axios.request({
    url: `/warehouse/number/inbound/save`,
    method: "post",
		data
  });
};

export const inboundList = params => {
  return axios.request({
    url: `/warehouse/number/inbound/list/`+params.id,
    method: "get",
  });
};

export const printTag = id => {
  return axios.request({
    url: `/warehouse/number/inbound/printTag/`+id,
    method: "get",
  });
};
